import { render, staticRenderFns } from "./aboutUsLayout.vue?vue&type=template&id=a40301a0&scoped=true&"
import script from "./aboutUsLayout.vue?vue&type=script&lang=js&"
export * from "./aboutUsLayout.vue?vue&type=script&lang=js&"
import style0 from "./aboutUsLayout.vue?vue&type=style&index=0&id=a40301a0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40301a0",
  null
  
)

export default component.exports